import { render, staticRenderFns } from "./PublicNewsDetailScreen.vue?vue&type=template&id=7a1833d9&"
import script from "./PublicNewsDetailScreen.vue?vue&type=script&lang=js&"
export * from "./PublicNewsDetailScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports